import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Result, Typography } from "antd";
import { useParams } from "react-router-dom";
const { Paragraph, Text } = Typography;
const ErrorPage = () => {
  const {id} = useParams()
  return (
  <Result
    status="error"
    title={`Error! ${id}`}
    subTitle="Please check and modify the following information before resubmitting."
    // extra={[
    //   <Button type="primary" key="console">
    //     Go Console
    //   </Button>,
    //   <Button key="buy">Buy Again</Button>,
    // ]}
  ></Result>
)};
export default ErrorPage;
